/* eslint-disable indent */
export default {
    token: '',
    user: {},
    prizesCodes: [],
};
